import React from 'react';
import EdgeFlowers from '../EdgeFlowers';
import './GameLayoutTopbar.css';

/**
 * Game layout with an info bar on top and a full-width game area below.
 * Fits within viewport height (accounts for TopMenu).
 * The info bar sizes to its content; the game area fills the remainder.
 *
 * @param {React.ReactNode} infoPanel - Content for the top info bar (level, round, instructions, etc.)
 * @param {React.ReactNode} gameArea - Content for the main game area
 * @param {string} [className] - Optional additional class name
 */
function GameLayoutTopbar({ infoPanel, gameArea, className = '' }) {
  return (
    <div className={`game-layout-topbar ${className}`.trim()}>
      <EdgeFlowers />
      <div className="game-layout-topbar__info">
        {infoPanel}
      </div>
      <div className="game-layout-topbar__game">
        {gameArea}
      </div>
    </div>
  );
}

export default GameLayoutTopbar;
